import React from "react";

import "../../../styles/tutorial.scss";

function SenaDivertidu({ name }) {
  return (
    <div class="container_como_jogar">
      <div>
        <h1 className="center capitalize">{name}</h1>

        <p>
          Para concorrer a prêmios de até 120.000,00 reais na{" "}
          <b className="capitalize">{name}</b>, você precisa acertar as 6
          dezenas sorteadas. Para acertar essas dezenas, você que escolhe se
          deseja ter mais chance ou menos chance, podendo escolher de 10 a 40
          dezenas entre às 60 disponíveis. Desta forma, a quantidade escolhida e
          o valor apostado determinarão o valor do seu prêmio.
        </p>
      </div>
    </div>
  );
}

export default SenaDivertidu;



// WEBPACK FOOTER //
// ./src/static/tutorial/concurso/sena-divertidu.jsx